$.get('/api/quickbooks/companies', function (data) {
  var rows = ''

  for (var i = 0; i < data.length; i++) {
    var company = data[i]

    rows += `<tr><td>${company.name}</td><td>${company.updatedAt}</td><td><input type="checkbox" class="company-status" data-id="${company.id}" ${company.disabledAt ? 'checked': ''}></td></tr>`
  }
  $('#companies-table tbody').html(rows)
})

$(document).on('change', ".company-status", function() {
  var elem
  elem = $(this)
  $.ajax('/api/quickbooks/companies/' + elem.data('id') + '/changestatus', 
    {
      type: 'GET',
      success: function (data) {
        if (data.ok) {
          window.location.reload()
        }
      }
    }
  )
})

document.getElementById('quickbooks-settings-form').addEventListener('submit', function (e) {
  e.preventDefault()

  var error
  if (document.getElementById('quickbooks-consumer-key').value.length !== 50) {
    error = 'QuickBooks Consumer Key must be exactly 50 characters long'
  } else if (document.getElementById('quickbooks-consumer-secret').value.length !== 40) {
    error = 'QuickBooks Consumer Secret must be exactly 40 characters long'
  }

  if (error) {
    document.querySelector('#quickbooks-settings-form .error-alert').classList.remove('sr-only')
    document.querySelector('#quickbooks-settings-form .error-alert .message').innerHTML = error
    return
  }

  document.querySelector('#quickbooks-settings-form button[type="submit"]').classList.add('sr-only')
  $.ajax('/api/quickbooks/settings',
    {
      type: 'POST',
      data: JSON.stringify({
        quickbooksConsumerKey: document.getElementById('quickbooks-consumer-key').value,
        quickbooksConsumerSecret: document.getElementById('quickbooks-consumer-secret').value,
        quickbooksSandbox: document.getElementById('quickbooks-sandbox').checked ? 'true' : 'false'
      }),
      success: function (data) {
        if (data.ok) {
          window.location.reload()
        } else {
          document.querySelector('#quickbooks-settings-form .error-alert').classList.remove('sr-only')
          document.querySelector('#quickbooks-settings-form .error-alert .message').innerHTML = 'There was an error submitting your data.'
        }
      },
      contentType: 'application/json',
      dataType: 'json'
    }
  )
})
